import React from "react";

import PageContent from "2g-page-content";
import Widget from "2g-widget";

import useMessages from "./i18n/useMessages";
import RezervaceVytvoreniForm from "b2b/components/rezervace-vytvoreni/RezervaceVytvoreniForm";

function RezervaceVytvoreni() {
  const messages = useMessages();
  return (
    <div className="b2b-RezervaceVytvoreni">
      <PageContent>
        <Widget title={messages.pageHeading()} collapsable={false}>
          <RezervaceVytvoreniForm />
        </Widget>
      </PageContent>
    </div>
  );
}

export default React.memo(RezervaceVytvoreni);
